import { MutationTree } from 'vuex';
import { IRecipientState } from '@/dealroom/recipients/store/recipient.types';
import { ERecipientMutation } from '@/dealroom/recipients/store/recipient.constants';
import { IRecipient } from '@/types/Recipient';

export const mutations: MutationTree<IRecipientState> = {
  [ERecipientMutation.SetModalVisibility](state: IRecipientState, show: boolean) {
    state.showModal = show;
  },
  [ERecipientMutation.UpdateSearchRecipientResult](
    state: IRecipientState,
    searchResult: IRecipient[]
  ) {
    state.searchRecipientList = searchResult;
  },
  [ERecipientMutation.UpdateEditRecipient](state: IRecipientState, recipient: IRecipient) {
    state.recipientModalInfo = recipient;
  },
  [ERecipientMutation.SetIsLoading](state: IRecipientState, isLoading: boolean) {
    state.isLoading = isLoading;
  },
};
